import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import appConfig from '../config/app-config';

@Injectable({
  providedIn: 'root'
})

export class AnalyticsService {

  constructor(private http: HttpClient) {
  }

  public httpGet(url: any) {
    return this.http.get(appConfig.analyticsBaseUrl + url)
  }
}
